var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import ReactSelect from 'react-select';
var InputSelect = /** @class */ (function (_super) {
    __extends(InputSelect, _super);
    function InputSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (value) {
            var _a = _this.props, onChange = _a.onChange, saveLSKeyId = _a.saveLSKeyId;
            if (saveLSKeyId && value && value.value) {
                localStorage.setItem(saveLSKeyId, JSON.stringify(value.value));
                onChange(value);
            }
            else {
                onChange(value);
            }
        };
        _this.getValue = function () {
            var _a = _this.props, saveLSKeyId = _a.saveLSKeyId, options = _a.options, value = _a.value;
            if (saveLSKeyId) {
                var savedValue_1 = JSON.parse(localStorage.getItem(saveLSKeyId));
                if (savedValue_1 && options && Array.isArray(options)) {
                    var selectedOption = options.find(function (item) { return item.value == savedValue_1; });
                    if (selectedOption) {
                        value = selectedOption;
                    }
                }
            }
            return value;
        };
        return _this;
    }
    InputSelect.prototype.render = function () {
        var _a = this.props, defaultValue = _a.defaultValue, isDisabled = _a.isDisabled, isLoading = _a.isLoading, isClearable = _a.isClearable, isSearchable = _a.isSearchable, options = _a.options, placeholder = _a.placeholder, name = _a.name, className = _a.className, autoFocus = _a.autoFocus, isRounded = _a.isRounded, id = _a.id, instanceId = _a.instanceId, size = _a.size, isOptionDisabled = _a.isOptionDisabled;
        return (React.createElement(ReactSelect, { id: id, autoFocus: autoFocus, className: 'gr-select ' +
                (isRounded ? 'round ' : '') +
                (size ? size : 'lg') +
                ' ' +
                (className ? className : ''), defaultValue: defaultValue, blurInputOnSelect: true, isDisabled: isDisabled, isLoading: isLoading, isClearable: isClearable, isSearchable: isSearchable, name: name, isOptionDisabled: isOptionDisabled, options: options, placeholder: placeholder ? placeholder : 'Выбрать…', onChange: this.onChange, instanceId: instanceId, value: this.getValue(), classNamePrefix: 'gr-input-select' }));
    };
    return InputSelect;
}(Component));
export default InputSelect;
//# sourceMappingURL=InputSelect.js.map